import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './Contact.css';
import ContactForm from './ContactForm.js';
import { Link } from 'react-router-dom';
import { FaLinkedin } from "react-icons/fa";





function Contact() {

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
            }
        },
        { threshold: 0.1 }
    );






    
    if (sectionRef.current) {
        observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  
  return (
    <section id="contact" className="py-20 bg-gray-50" ref={sectionRef}>
      <div className="max-w-4xl mx-auto px-6">
          <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Don't See What You Need?</h2>
              <p className="text-xl text-gray-600">We can tailor your request even further.</p>
          </div>

          <div className="flex justify-center">
                <button 
                    // onClick={handleLearnMore}
                    className="bg-blue-900 hover:bg-red-400 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-md font-semibold transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto"
                >
                    <Link to="https://bambootradesllc.hbportal.co/public/projecthelp" target="_blank" rel="noopener noreferrer">Get Help</Link>
                </button>
          </div>
      </div>
    </section>
  );
}

export default Contact;